import { useEffect, useRef, useState } from 'react';
import api from '../../../../api';
import useFlashMessage from '../../../../hooks/useFlashMessage';

export function useRelatorioModule({ mrt, periodo, permissoes, tipo }) {
    const [gerando, setGerando] = useState(false);
    const trava = useRef(false), contexto = useRef(0), urls = useRef([]);
    const { setFlashMessage } = useFlashMessage();
    const empresaId = localStorage.getItem('empresaId');
    useEffect(() => {
        contexto.current += 1; trava.current = false; setGerando(false);
        return () => { contexto.current += 1; urls.current.forEach(url => URL.revokeObjectURL(url)); urls.current = []; };
    }, [empresaId, permissoes.autorizado, permissoes.imprimir, tipo]);
    const gerar = async () => {
        if (tipo || trava.current || !permissoes.autorizado || !permissoes.imprimir) return;
        if (periodo.dataInicio && periodo.dataFim && periodo.dataInicio > periodo.dataFim) {
            setFlashMessage('A data inicial deve ser anterior ou igual à data final.', 'warning'); return;
        }
        const ctx = contexto.current;
        trava.current = true; setGerando(true);
        let janela = null;
        try {
            try {
                janela = window.open('about:blank', '_blank');
                if (janela) { janela.opener = null; janela.document.title = 'Relatório de documentos'; janela.document.body.textContent = 'Gerando relatório...'; }
            } catch { if (janela) janela.close(); janela = null; }
            const { data } = await api.get('/arquivoDocumento/relatorio', { responseType: 'blob', params: {
                filters: JSON.stringify(mrt.columnFilters), filtersMode: JSON.stringify(mrt.columnFilterFns),
                sorting: JSON.stringify(mrt.sorting), globalFilter: mrt.globalFilter, ...periodo,
            } });
            if (ctx !== contexto.current) return;
            const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
            urls.current.push(url);
            if (janela && !janela.closed) { janela.location.replace(url); janela = null; }
            else {
                const a = document.createElement('a'); a.href = url; a.download = 'arquivo-documentos.pdf';
                document.body.appendChild(a); a.click(); a.remove();
                setFlashMessage('Relatório gerado. Abra o PDF baixado para visualizar ou imprimir.', 'success');
            }
        } catch(e) {
            let mensagem = e.response?.data?.message || e.message || 'Erro ao gerar relatório.';
            if (e.response?.data instanceof Blob) {
                try { mensagem = JSON.parse(await e.response.data.text()).message || mensagem; } catch { /* Mantém mensagem original. */ }
            }
            if (ctx === contexto.current) setFlashMessage(mensagem, 'error');
        } finally {
            if (janela && !janela.closed) janela.close();
            if (ctx === contexto.current) { trava.current = false; setGerando(false); }
        }
    };
    return { gerar, gerando };
}
